import { INotificationState } from '../interfaces/inotification-state';

export const NOTIFICATIONS_STATE: INotificationState = {
  notifications: [],
  containerIsActive: false,
  unread: 0,
  enabled: true,
};
